import React from 'react'
import { Tooltip } from '@telavita-core/react-design-kit'
import { ReactComponent as QuestionMarkIcon } from 'static/svg/icon-question-mark.svg'
import * as S from './styles'

interface Props {
  value: number;
  label: string;
  tooltip: string;
  color?: 'default' | 'primary' | 'danger';
  hint?: string;
}

export const CapacityCounter: React.FC<Props> = ({ value, label, tooltip, color = 'default', hint }) => (
  <S.CounterCard>
    <Tooltip content={<S.TooltipContent>{tooltip}</S.TooltipContent>} arrow theme='light' placement='bottom' maxWidth={200}>
      <S.HelpButton aria-label={`Ajuda: ${label}`} type="button">
        <QuestionMarkIcon aria-hidden="true" />
      </S.HelpButton>
    </Tooltip>
    <S.Value $color={color}>{value}</S.Value>
    <S.Label $color={color}>{label}</S.Label>
    {hint && <S.Hint>{hint}</S.Hint>}
  </S.CounterCard>
)
